<template>
  <div>
    <v-tooltip
      top
      max-width="250px"
    >
      <template #activator="{ on, attrs }">
        <div
          class="text-center container-info"
          :class="{
            'is_current' : cycle.is_current
          }"
          v-bind="attrs"
          v-on="on"
          @click="onClick"
        >
          <span
            class="rounded-circle border d-inline-block p-1 p-sm-3 d-flex justify-content-center align-items-center info-text"
            :class="{
              'purple' : (progress >= 100 && !cycle.is_current) && !module.disabled,
              'purple--border' : (progress < 100 && !cycle.is_current) && !module.disabled,
              'white--border' : cycle.is_current && !module.disabled,
              'white' : (progress >= 100 && cycle.is_current) && !module.disabled,
              'purple--text' : !cycle.is_current && !module.disabled,
              'border-gray-400' : module.disabled
            }"
          >
            <p
              class="text-center font-weight-bold"
              :class="{
                'white--text' : ((!cycle.is_current && progress >= 100) || cycle.is_current && progress < 100) && !module.disabled,
                'nitro--text' : (cycle.is_current && progress >= 100) && !module.disabled,
                'gray-400--text' : module.disabled
              }"
            >
              {{ progress }}%
            </p>
          </span>
          <p
            class="text-center sub-text"
            :class="{
              'white--text' : cycle.is_current && !module.disabled,
              'gray-400--text' : module.disabled
            }"
          >
            M{{ module.module_order }}
          </p>
        </div>
      </template>
      <p
        v-if="module.disabled"
        class="text-center m-0"
      >
        O acesso a esse módulo só será liberado no dia {{ $moment(module.begin).format('DD/MM') }}
      </p>
      <span v-else>
        <p>
          {{ module.type == 'theme' ? module.block.name : module.subject_name }}: <span>{{ module.name }}</span>
        </p>
        <p class="m-0">
          Janela: <span> {{ $moment(module.begin_date).format('DD/MM') }} a {{ $moment(module.end_date).format('DD/MM') }}</span>
        </p>
        <p class="m-0">
          Progresso na meta: <span> {{ module.goal_progress }}%</span>
        </p>
        <p class="m-0">
          Progresso geral: <span> {{ module.module_progress }}%</span>
        </p>
        <p class="m-0">
          Conteúdos concluídos: <span> {{ module.count_completed_contents }} / {{ module.count_contents }}</span>
        </p>
      </span>
    </v-tooltip>
  </div>    
</template>
<script>
import { showModuleRouteName } from '../../../constants/routes';

export default {
    props: {
        module: {
            type:Object,
            required:true,
        },
        cycle: {
            type:Object,
            required:true,
        }
    },
    data(){
        return {
            showModuleRouteName
        }
    },
    computed: {
      progress(){
        return this.cycle.order == 0 ? this.module.module_progress : this.module.goal_progress
      }
    },
    methods: {
      onClick(){
        if(!this.module.disabled){
          this.$router.push( { name: showModuleRouteName, params: { module_id: this.module.id }})
        }
      }
    }
}
</script>
<style scope lang="scss">
p {
    margin: 0;
    span {
        font-weight: bold;
    }
}
</style>